import { Component, OnInit, inject } from "@angular/core";
import { provideTranslocoScope, TranslocoService } from "@jsverse/transloco";
import { firstValueFrom } from "rxjs";
import { DashboardWidgetMapping } from "../shared/DashboardWidgetMapping";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { DashboardWidgetModel } from "../shared/models/DashboardWidgetModel";

@Component({
    selector: "widget-market",
    templateUrl: "./widget-market.component.html",
    styleUrls: ["./widget-market.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope("dashboard")],
})
export class WidgetMarketComponent implements OnInit {
    private _permService = inject(PermissionsService);
    private _transloco = inject(TranslocoService);

    marketWidgets: DashboardWidgetModel[];
    filteredMarketWidgets: DashboardWidgetModel[];

    draggingMarketItem: DashboardWidgetModel;

    async ngOnInit() {
        await firstValueFrom(this._transloco.load(`dashboard/${this._transloco.getActiveLang()}`));
        this.initMarketItems();
        this.filter(null);
    }

    dragStartHandler(ev: DragEvent, draggingItem: DashboardWidgetModel) {
        this.draggingMarketItem = draggingItem;

        ev.dataTransfer.setData("text/plain", JSON.stringify(draggingItem.customConfig));
        ev.dataTransfer.dropEffect = "copy";
    }

    filter(filterString: string) {
        if (!filterString || filterString.trim() === "") {
            this.filteredMarketWidgets = this.marketWidgets;
            return;
        }

        filterString = filterString.trim().toLowerCase();

        this.filteredMarketWidgets = this.marketWidgets.filter((mw) => {
            const title = this._transloco.translate(mw.title);
            const description = mw.description ? this._transloco.translate(mw.description) : "";
            return (
                title.toLowerCase().indexOf(filterString) >= 0 ||
                description.toLowerCase().indexOf(filterString) >= 0
            );
        });
    }

    private initMarketItems() {
        const allWidgets = DashboardWidgetMapping.all();
        const sortedWidgets = this.SortWidgets(allWidgets);

        this.marketWidgets = sortedWidgets.filter((widget) => {
            if (!widget.right) {
                return true;
            }

            return this._permService.hasStringRight(widget.right);
        });
    }

    private SortWidgets(widgets: DashboardWidgetModel[]) {
        var sortedWidgets = widgets.sort((n1, n2) => {
            const title1 = this._transloco.translate(n1.title).toLocaleLowerCase();
            const title2 = this._transloco.translate(n2.title).toLocaleLowerCase();

            if (title1 > title2) {
                return 1;
            }

            if (title1 < title2) {
                return -1;
            }

            return 0;
        });
        return sortedWidgets;
    }
}
